export const Hobbies = axios => ({
  /**
   * Get hobbies list
   *
   * @returns Promise
   */
  list() {
    return axios.get('/v1/hobbies')
  }
})
